import * as React from "react";
import Svg from "./StyledSvg";
type Props = {
  size?: "XS" | "S" | "M" | "L" | "XL" | "XXL";
  color?: string;
  style?: object;
};

interface SizeData {
    size: number;
    stroke: number;
  }

  interface AvailableSizes {
    XS: SizeData;
    S: SizeData;
    M: SizeData;
    L: SizeData;
    XL: SizeData;
    XXL: SizeData;
  }
  ;
const availableSizes: AvailableSizes = {"XS":{"size":16,"stroke":1.3},"S":{"size":20,"stroke":1.5},"M":{"size":24,"stroke":1.8},"L":{"size":40,"stroke":2.2},"XL":{"size":48,"stroke":2.5},"XXL":{"size":70,"stroke":2.8}};
function QrCode({
  size = "M",
  color = "currentColor",
  style
}: Props): React.JSX.Element {
  const strokeWidth = availableSizes[size]?.stroke;
  const appliedSize = availableSizes[size]?.size;
  return <Svg width={appliedSize} height={appliedSize} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" color={color} style={style}><path vectorEffect="non-scaling-stroke" d="M16 21H18C19.65 21 21 19.65 21 18V16M16 3H18C19.65 3 21 4.34 21 6V8M3 16V18C3 19.65 4.34 21 6 21H8M3 8V6C3 4.34 4.34 3 6 3H8M13.55 13.5H13.54L13.53 13.49V13.48M16.955 13.5H16.945L16.935 13.49V13.48M13.55 17H13.54L13.53 16.99V16.98M16.95 17H16.94L16.93 16.99V16.98M15.255 15.25H15.245L15.235 15.24V15.23M13.999 7H16.499C16.7751 7 16.999 7.22386 16.999 7.5V10C16.999 10.2761 16.7751 10.5 16.499 10.5H13.999C13.7229 10.5 13.499 10.2761 13.499 10V7.5C13.499 7.22386 13.7229 7 13.999 7ZM7.499 7H9.999C10.2751 7 10.499 7.22386 10.499 7.5V10C10.499 10.2761 10.2751 10.5 9.999 10.5H7.499C7.22286 10.5 6.999 10.2761 6.999 10V7.5C6.999 7.22386 7.22286 7 7.499 7ZM7.499 13.5H9.999C10.2751 13.5 10.499 13.7239 10.499 14V16.5C10.499 16.7761 10.2751 17 9.999 17H7.499C7.22286 17 6.999 16.7761 6.999 16.5V14C6.999 13.7239 7.22286 13.5 7.499 13.5Z" stroke="currentColor" strokeWidth={strokeWidth} strokeLinecap="round" strokeLinejoin="round" /></Svg>;
}
export default QrCode;